
import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";


export const getJobActions = (PageNumber: number, PageSize: number, jobId: any) => http({
    url: ENDPOINTS.cartable.action.jobActions,
    method: 'get',
    params: {
        pageNumber: PageNumber,
        pageSize: PageSize,
        jobId,
    }
}).then((res) => {
    
    return res.data
}).catch((err) => {
    return Promise.reject( err);
});